const COLORSlIST: string[] = [
  "#C8C97C",
  "#A8DFFF",
  "#86BC25",
  "#84B2AE",
  "#6CFBD3",
  "#54667E",
  "#52C0EA",
  "#2C5234",
  "#29B8B8",
  "#0CDF00",
  "#009A44",
  "#005057",
  "#00405C",
  "#003A5C",
  "#D2E03D",
  "#D1D282",
  "#9DD690",
  "#8ABBB6",
  "#7CB298",
  "#7AA7C2",
  "#4DFACA",
  "#40546F",
  "#3DB9E7",
  "#0DF200",
  "#00ABAB",
  "#005A61",
  "#005478",
  "#004167",
  "#E3E48D",
  "#CDDD29",
  "#92D1C6",
  "#90C3BE",
  "#86B9D6",
  "#7FC96E",
  "#7AA3A9",
  "#549A78",
  "#2FBE96",
  "#2C4260",
  "#29B2E5",
  "#00636C",
  "#005E86",
  "#004771",
  "#9DD4CF",
  "#95A300",
  "#8DC2E0",
  "#81BFC5",
  "#7BC7BA",
  "#70C35D",
  "#52878E",
  "#34D2A5",
  "#041E42",
  "#02371D",
  "#00A3E0",
  "#007680",
  "#006894",
  "#005587",
  "#E5F3EE",
  "#95A300",
  "#93CAEB",
  "#88C7EB",
  "#7B8CB1",
  "#7AC9D2",
  "#7AB8D2",
  "#61BD4C",
  "#5AABB4",
  "#549389",
  "#37DCAD",
  "#034826",
  "#007CB0",
  "#00292E",
  "#E0F0EA",
  "#ACBC00",
  "#A0DCFF",
  "#8EC281",
  "#6FBBE7",
  "#64F4FF",
  "#5DA397",
  "#52B8C5",
  "#52A2C4",
  "#526899",
  "#43B02A",
  "#39E6B5",
  "#07444B",
  "#03512B",
  "#00363D",
  "#B4C500",
  "#A8B6B0",
  "#A3CC59",
  "#91A595",
  "#6BAF5A",
  "#62AB9E",
  "#4A8AAE",
  "#43F1FF",
  "#3EFAC5",
  "#3E568D",
  "#3DB0BE",
  "#095962",
  "#03592F",
  "#003D57",
  "#003C44",
  "#C4D600",
  "#BAC9C3",
  "#99C748",
  "#708975",
  "#66B2A6",
  "#5298C0",
  "#47F53D",
  "#2A4581",
  "#29A8B7",
  "#27B6C2",
  "#144707",
  "#0A646D",
  "#046A38",
  "#005072",
  "#00424B",
  "#EAEAA8",
  "#C2D2CC",
  "#7ACA9E",
  "#6FC2B4",
  "#668F1C",
  "#569FCA",
  "#2BCAD6",
  "#20F314",
  "#1A5D09",
  "#172B1B",
  "#0B6E79",
  "#012169",
  "#0097A9",
  "#005A80",
  "#004F59",
  "#E7E89F",
  "#CBDCD5",
  "#B5DEDB",
  "#7AD3D3",
  "#7AB8BD",
  "#7AA7C1",
  "#719E1F",
  "#5AA7D3",
  "#52BA80",
  "#2DD3E0",
  "#1E3823",
  "#1D680A",
  "#0D8390",
  "#0AB800",
  "#00638D",
  "#DDEFE8",
  "#ADAD6B",
  "#A5D7D3",
  "#7ABBD6",
  "#76A521",
  "#62B5E5",
  "#52C6C6",
  "#52A2A9",
  "#528BAD",
  "#3DB271",
  "#2FDDEB",
  "#213E28",
  "#20730B",
  "#0BCB00",
  "#0076A8",
  "#BFC076",
  "#B7E4FF",
  "#7C8A9D",
  "#7BAD22",
  "#7ACFEF",
  "#77A19D",
  "#52A6C9",
  "#3DBFBF",
  "#33F0FF",
  "#29AA62",
  "#26890D",
  "#25452C",
  "#0BD500",
  "#003D43",
  "#002C46",
];
export default COLORSlIST;

export const CAT_COLORS_LIST: Record<string, string> = {
  NEUTRAL: "#00A3E0",
  PRODUCTIVE: "#43B02A",
  UNPRODUCTIVE: "#ED8B00",
  UNCATEGORISED: "#63666A",
};
